import request from '@/assets/util/request'   //ajax请求

export const personList = (data)=> {
    return request({
        url: `/agent/api/employee/list`,
        method: 'post',
        data: data,
        params:data
    })
}


export const personDetail = (data)=> {
    return request({
        url: `/agent/api/employee/${data.id}`,
        method: 'get',
        data: data,
        params:data
    })
}


export const personBehavior = (data)=> {
    return request({
        url: `/agent/api/employee/behavior/list`,
        method: 'post',
        params:data,
        data: data,
    })
}



